const Login = () => {
  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold mb-6">Login</h1>
      <p className="text-lg mb-4">
        Access your MAAP member account.
      </p>
    </div>
  );
};

export default Login; 